import React from "react";
import ReportLayout from "../components/ReportLayout";
import dayjs from "dayjs";

const presetOP = {
    label: "ОП",
    sources: [1,2,4],
    statuses: [1,3,4,5,6],
    selectedManagers: [5,6,11],
    tagFilterMode: "no_both",
    rangeDate: "day",
    // fetchLiveToday: true,
    columns: {
        date: true,             // Період
        ordersCount: true,      // Кількість замовлень
        directManager: true,
        leads: true,            // Ліди
        tickets: true,          // Діалоги
        total: true,            // Сума замовлень
        cost: false,             // Собівартість
        margin: false,
        payments: false,         // Сума оплат
        avgCheck: true,         // Середній чек
        ads: false,              // Кількість РК
        spend: false,            // Рекламний бюджет
        clicks: false,           // Кількість кліків
        impressions: false,      // Кількість показів
        upsales: true,          // Допродаж
        repeatSales: true,      // Повторні продажі
        saleOrders: true,       // Розпродажі
        itemsCount: true,       // Кількість речей
        productBreakdown: true  // Колонки с названиями товаров
    },
    range: {
        startDate: dayjs().startOf("month").toDate(),
        endDate: dayjs().endOf("month").toDate()
    }
};

const ReportsOPTable = ({user}) => {
    return (
        <ReportLayout
            title="Таблиця Відділу продажу"
            preset={presetOP}
            user={user}
        />
    );
};

export default ReportsOPTable;